var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defaultBaseEHRNote } from './baseNoteSchema';
import { primaryTherapeuticApproaches, usedSubstance, } from 'constants/ehrNoteEnums';
import { ehrNoteSchemaInstance } from './intakeFollowUpNoteSchema';
var defaultEmptyNote = Object.freeze(__assign(__assign({}, defaultBaseEHRNote), { memberHistory: {
        behavioralHealthHistory: {
            previousProblems: [],
        },
        substanceUseAbuse: {
            substances: [
                {
                    name: usedSubstance.alcohol,
                    comments: '',
                },
                {
                    name: usedSubstance.nicotine,
                    comments: '',
                },
                {
                    name: usedSubstance.caffeine,
                    comments: '',
                },
                {
                    name: usedSubstance.cannabis,
                    comments: '',
                },
            ],
        },
    }, subjective: {
        presentingProblem: '',
        sessionFocus: '',
    }, objective: {
        vitals: {
            weight: 0,
            height: {
                feet: 0,
                inches: 0,
            },
            temperature: 0,
            respiratoryRate: 0,
            heartRate: 0,
            bloodPressure: {
                systolic: 0,
                diastolic: 0,
            },
        },
    }, assessment: {
        diagnoses: [],
    }, plan: {
        primaryTherapeuticApproaches: [primaryTherapeuticApproaches.medicationManagement],
    } }));
var stripOptionalEnums = function (obj) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!Array.isArray(obj.plan.primaryTherapeuticApproaches)) {
        delete obj.plan.primaryTherapeuticApproaches;
    }
    if (obj.plan.plannedFrequencyOfEngagementWithClient === '') {
        delete obj.plan.plannedFrequencyOfEngagementWithClient;
    }
    if (((_a = obj.assessment.riskConcerns) === null || _a === void 0 ? void 0 : _a.riskForHarmToSelf) === '') {
        delete obj.assessment.riskConcerns.riskForHarmToSelf;
    }
    if (((_b = obj.assessment.riskConcerns) === null || _b === void 0 ? void 0 : _b.riskForHarmToOthers) === '') {
        delete obj.assessment.riskConcerns.riskForHarmToOthers;
    }
    if (((_c = obj.objective.vitals) === null || _c === void 0 ? void 0 : _c.dataSource) === '') {
        (_d = obj.objective.vitals) === null || _d === void 0 ? true : delete _d.dataSource;
    }
    for (var _i = 0, _h = (_g = (_f = (_e = obj.memberHistory) === null || _e === void 0 ? void 0 : _e.substanceUseAbuse) === null || _f === void 0 ? void 0 : _f.substances) !== null && _g !== void 0 ? _g : []; _i < _h.length; _i++) {
        var substance = _h[_i];
        if (!substance.currentUse) {
            delete substance.currentUse;
        }
    }
    var id = obj.id, createdAt = obj.createdAt, updatedAt = obj.updatedAt, signedAt = obj.signedAt, otherFields = __rest(obj, ["id", "createdAt", "updatedAt", "signedAt"]);
    return __assign({}, otherFields);
};
export var makeVitalsNumeric = function (obj) {
    if (obj.objective.vitals) {
        obj.objective.vitals.weight = Number(obj.objective.vitals.weight);
        obj.objective.vitals.height.feet = Number(obj.objective.vitals.height.feet);
        obj.objective.vitals.height.inches = Number(obj.objective.vitals.height.inches);
        obj.objective.vitals.temperature = Number(obj.objective.vitals.temperature);
        obj.objective.vitals.respiratoryRate = Number(obj.objective.vitals.respiratoryRate);
        obj.objective.vitals.heartRate = Number(obj.objective.vitals.heartRate);
        obj.objective.vitals.bloodPressure.diastolic = Number(obj.objective.vitals.bloodPressure.diastolic);
        obj.objective.vitals.bloodPressure.systolic = Number(obj.objective.vitals.bloodPressure.systolic);
    }
    return obj;
};
export var adultMedManagementNoteSchemaInstance = {
    defaultValues: defaultEmptyNote,
    useDeprecatedFields: function (ldClient) {
        var ehrDeprecatedFields = ehrNoteSchemaInstance.useDeprecatedFields(ldClient);
        // MM notes have a field at this location, but therapist notes are deprecating it in separate PR
        var otherMedicationsIndex = ehrDeprecatedFields.indexOf('memberHistory.medications.otherMedications');
        if (otherMedicationsIndex >= 0)
            ehrDeprecatedFields.splice(otherMedicationsIndex, 1);
        return ehrDeprecatedFields;
    },
    useDeprecatedValues: function (ldClient) { return (__assign({}, ehrNoteSchemaInstance.useDeprecatedValues(ldClient))); },
    prepareFormForSave: function (form) { return (__assign({}, stripOptionalEnums(makeVitalsNumeric(form.getValues())))); },
    prepareExistingNote: function (note) { return (__assign({}, note)); },
};
